import { useEffect, useState } from 'react';
import { AppState } from 'react-native';
import { festivalToday } from 'app/lib/festival-date';

export function useFestivalToday() {
  const [today, setToday] = useState(() => festivalToday());
  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    const update = () => setToday(festivalToday());
    const tick = () => {
      update();
      timer = setTimeout(tick, 60_000 - (Date.now() % 60_000));
    };
    timer = setTimeout(tick, 60_000 - (Date.now() % 60_000));
    const subscription = AppState.addEventListener('change', (state) => {
      if (state === 'active') update();
    });
    return () => {
      clearTimeout(timer);
      subscription.remove();
    };
  }, []);
  return today;
}
